import { baseRequest } from './request';

/**
 * Sends GET request to the specified URL.
 *
 * @param {String} url URL to send the GET request.
 */
const get = (url, queryParams, options = {}) =>
  baseRequest(url, queryParams, {
    method: 'GET',
    ...options,
  });

const getReport = (url, queryParams, options = {}) =>
  baseRequest(url, queryParams, {
    method: 'GET',
    responseType: 'arraybuffer',
    ...options,
  });

/**
 * Sends POST request to the specified URL with the specified body.
 *
 * @param {String} url URL to send the POST request.
 * @param {Object} data Data to be sended as request body.
 */
const post = (url, data, queryParams = null, options = {}) =>
  baseRequest(url, queryParams, {
    method: 'POST',
    data,
    options,
  });

/**
 * Sends PATCH request to the specified URL with the specified body.
 *
 * @param {String} url URL to send the PATCH request.
 * @param {Object} data Data to be sended as request body.
 */
const patch = (url, data, queryParams) =>
  baseRequest(url, queryParams, {
    method: 'PATCH',
    data,
  });

/**
 * Sends PUT request to the URL with the specified body.
 *
 * @param {String} url URL to send the PUT request.
 * @param {Object} data Data to be sended as request body.
 */
const put = (url, data, queryParams, options = {}) =>
  baseRequest(url, queryParams, {
    method: 'PUT',
    data,
    options,
  });
/**
 * Sends DELETE request to the specified URL with the specified resource id.
 *
 * @param {String} url URL to send the PATCH request.
 * @param {Object} data Request body of the delete request.
 */
const remove = (url, data, queryParams) =>
  baseRequest(url, queryParams, {
    method: 'DELETE',
    data,
  });

export default {
  get,
  getReport,
  post,
  patch,
  put,
  remove,
};
